<!-- src/components/shared/LoadingSpinner.vue -->
<template>
  <div class="loading-spinner" :class="{ inline: inline }">
    <div class="spinner" :style="spinnerStyle"></div>
    <p v-if="text" class="spinner-text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',

  props: {
    /** Текст под спиннером */
    text: {
      type: String,
      default: '',
    },
    /** Размер спиннера */
    size: {
      type: Number,
      default: 50,
    },
    /** Цвет спиннера */
    color: {
      type: String,
      default: '#0095ec',
    },
    /** Inline режим (без центрирования) */
    inline: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    spinnerStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        borderTopColor: this.color,
      }
    },
  },
}
</script>

<style scoped>
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.loading-spinner.inline {
  padding: 20px;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #0095ec;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.spinner-text {
  margin-top: 20px;
  color: #64748b;
  font-size: 16px;
}
</style>